/* Helper Methods to get date */

// Taken from: https://stackoverflow.com/questions/1531093/how-do-i-get-the-current-date-in-javascript
export function mmddyyyy(timestamp) {
  let today = new Date(timestamp);
  if (!timestamp) today = new Date();

  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
  const yyyy = today.getFullYear();

  today = `${mm}/${dd}/${yyyy}`;
  return today;
}

export function monthNameDDYYYY(timestamp) {
  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  let today = new Date(timestamp);
  if (!timestamp) today = new Date();
  const monthName = monthNames[today.getMonth()];
  today = `${monthName} ${today.getDate()}, ${today.getFullYear()}`;
  return today;
}
